var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "copy_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M.5 0h16v16H.5z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#copy_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M4.333 14.205c-.336 0-.621-.117-.855-.35a1.163 1.163 0 0 1-.35-.855V5.038c0-.141.048-.26.144-.356a.484.484 0 0 1 .356-.144c.142 0 .26.048.357.144a.484.484 0 0 1 .143.356V13c0 .051.022.098.064.141.043.043.09.064.141.064h5.962c.142 0 .26.048.356.144a.484.484 0 0 1 .144.356c0 .142-.048.26-.144.357a.484.484 0 0 1-.356.143H4.333Zm2.334-2.333c-.337 0-.622-.117-.855-.35a1.163 1.163 0 0 1-.35-.855v-7.59c0-.337.116-.622.35-.855.233-.234.518-.35.855-.35h5.59c.336 0 .621.116.854.35.234.233.35.518.35.855v7.59c0 .336-.116.621-.35.855-.233.233-.518.35-.855.35h-5.59Zm0-1h5.59a.196.196 0 0 0 .14-.064.196.196 0 0 0 .064-.141v-7.59a.196.196 0 0 0-.064-.141.196.196 0 0 0-.14-.064h-5.59a.196.196 0 0 0-.141.064.196.196 0 0 0-.064.14v7.59c0 .052.02.099.064.142.042.042.09.064.14.064Z",
    fill: "currentColor"
  }))));
};
export default SvgCopy;